import type { GuestState } from './GuestApp';
import { Dot, Mango } from '../ui/icons';

export function Header({ s, sub }: { s: GuestState; sub: string }) {
  return (
    <header className="topbar">
      <div className="brand">
        <div className="logo"><Mango /></div>
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <span className="display" style={{ fontSize: 17, lineHeight: 1.1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.guest.restaurant}</span>
          <span className="muted" style={{ fontSize: 12 }}>{sub}</span>
        </div>
      </div>
      <div className="pill" title={s.online ? 'Live' : 'Reconnecting…'}>
        <span className="table-chip">{s.guest.tableName}</span>
        <Dot on={s.online} />
        <span className="sr-only" style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>{s.online ? 'Live' : 'Reconnecting'}</span>
      </div>
    </header>
  );
}
